/**
 * Scholar Review API composable (magic link token-authenticated)
 *
 * Unlike useFaraid.js which uses the global apiClient with localStorage auth,
 * this composable creates a dedicated axios instance that uses the magic link
 * token passed as a parameter. It does NOT redirect to /login on 401.
 */
import axios from 'axios'

export function useScholarReview(token) {
  const client = axios.create({
    baseURL: import.meta.env.VITE_API_URL || '',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    // Include X-Module header for subdomain routing bypass
    ...(import.meta.env.VITE_MODULE ? { headers: { 'X-Module': import.meta.env.VITE_MODULE } } : {}),
  })

  // Always set auth header (override the spread above)
  client.defaults.headers.common['Authorization'] = `Bearer ${token}`
  client.defaults.headers.common['Content-Type'] = 'application/json'

  // Add X-Module header if configured (for local dev)
  const moduleHeader = import.meta.env.VITE_MODULE
  if (moduleHeader) {
    client.defaults.headers.common['X-Module'] = moduleHeader
  }

  const getCaseData = () => client.get('/v1/faraid/review').then(r => r.data?.data)

  const approve = (data) => client.post('/v1/faraid/review/approve', data).then(r => r.data)

  const adjust = (data) => client.post('/v1/faraid/review/adjust', data).then(r => r.data)

  const override = (data) => client.post('/v1/faraid/review/override', data).then(r => r.data)

  const requestInfo = (data) => client.post('/v1/faraid/review/request-info', data).then(r => r.data)

  const uploadDocument = (file) => {
    const formData = new FormData()
    formData.append('document', file)
    return client.post('/v1/faraid/review/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then(r => r.data?.data)
  }

  return {
    getCaseData,
    approve,
    adjust,
    override,
    requestInfo,
    uploadDocument,
  }
}
